import { createContext, useState, useContext } from 'react';
import { createStore, useStore, StoreApi } from 'zustand';
import { User } from '@/types/user';

interface UserState {
  user: User;
  isAuthenticated: boolean;
}

// interface UserActions {
//   actions: {
//     setUser: (user: User) => void;
//     updateUser: (updates: Partial<User>) => void;
//   };
// }

type UserStore = UserState;
// & UserActions;

const UserStoreContext = createContext<StoreApi<UserStore> | null>(null);

const createUserStore = (initialUser: User) =>
  createStore<UserStore>(() => ({
    user: initialUser,
    isAuthenticated: Boolean(initialUser),
    // actions: {
    //   setUser: user => set({ user, isAuthenticated: Boolean(user) }),
    //   updateUser: updates =>
    //     set(state => ({ user: { ...state.user, ...updates } })),
    // },
  }));

export const UserStoreProvider: React.FC<{
  children: React.ReactNode;
  initialUser: User;
}> = ({ children, initialUser }) => {
  const [store] = useState(() => createUserStore(initialUser));

  return (
    <UserStoreContext.Provider value={store}>
      {children}
    </UserStoreContext.Provider>
  );
};

export const useUserStore = <T,>(selector: (state: UserStore) => T): T => {
  const store = useContext(UserStoreContext);
  if (!store) {
    throw new Error('Missing UserStoreProvider');
  }
  return useStore(store, selector);
};
